import ReactECharts from 'echarts-for-react';

/**
 * Reusable ECharts wrapper component
 * Provides consistent styling and configuration across all charts
 */
export default function EChart({ option, height = '300px', loading = false }) {
  // Default options for all charts
  const defaultOption = {
    backgroundColor: 'transparent',
    textStyle: {
      fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif'
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      top: '10%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      borderColor: '#e5e7eb',
      borderWidth: 1,
      textStyle: {
        color: '#374151'
      },
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    }
  };

  // Merge user options with defaults
  const mergedOption = {
    ...defaultOption,
    ...option,
    grid: {
      ...defaultOption.grid,
      ...option.grid
    },
    tooltip: {
      ...defaultOption.tooltip,
      ...option.tooltip
    }
  };

  return (
    <ReactECharts
      option={mergedOption}
      style={{ height, width: '100%' }}
      showLoading={loading}
      loadingOption={{
        text: 'Loading...',
        color: '#3b82f6',
        textColor: '#374151',
        maskColor: 'rgba(255, 255, 255, 0.8)',
        zlevel: 0
      }}
      opts={{ renderer: 'canvas' }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
}
